import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiButton } from '@elastic/eui';
import NavButtons from 'components/Downloads/Indoor_Cameras/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-8003 Full HD Downloads",
  "path": "/Downloadbereich/Innenkameras/IN-8003_HD/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Firmware, WebUI und Dokumentations-Downloads",
  "image": "./D_SearchThumb_8003.png",
  "social": "/images/Search/D_SearchThumb_Indoor_Cameras.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Downloads_white.webp",
  "chapter": "Downloads"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Downloadbereich - IN-8003 Full HD' dateChanged='2018-09-20' author='Mike Polinowski' tag='INSTAR IP Camera' description='Software Downloads und Handbücher für Ihre INSTAR Produkte' image='/images/Search/P_SearchThumb_IN-8003HD_Downloads.png' twitter='/images/Search/P_SearchThumb_IN-8003HD_Downloads.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Downloads/Indoor_Cameras/IN-8003_HD/' locationFR='/fr/Downloads/Indoor_Cameras/IN-8003_HD/' crumbLabel="IN-8003" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#downloads",
        "aria-label": "downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Downloads`}</h1>
    <h2 {...{
      "id": "indoor-cameras",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#indoor-cameras",
        "aria-label": "indoor cameras permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Indoor Cameras`}</h2>
    <h2 {...{
      "id": "in-8003-full-hd-downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-8003-full-hd-downloads",
        "aria-label": "in 8003 full hd downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8003 Full HD Downloads`}</h2>
    {
      /* TOC */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#software-installation-wizard"
        }}>{`Software Installation Wizard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#anleitungen"
        }}>{`Anleitungen`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#schnellinstallation"
            }}>{`Schnellinstallation`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#updates-kamera-software"
        }}>{`Updates Kamera-Software`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#firmware"
            }}>{`Firmware`}</a></li>
        </ul>
      </li>
    </ul>
    {
      /* /TOC */
    }
    <h2 {...{
      "id": "software-installation-wizard",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#software-installation-wizard",
        "aria-label": "software installation wizard permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software Installation Wizard`}</h2>
    <p>{`Jedes INSTAR Produkt wird mit einer Installations-CD ausgeliefert. Die CD beinhaltet einen Installationsassistenten der Sie durch die Einrichtung Ihres neuen INSTAR Produktes leitet. Der Installationsassistent kann auch direkt aufgerufen werden indem Sie unten auf den Link klicken und somit die CD online öffnen. Der Assistent enthält alle Informationen und aktuelle Download-Links die Sie für die Installation benötigen.`}</p>
    <p>{`Die Software CD beinhaltet einen HTML Einrichtungsassistenten der Sie durch die benötigten Einstellungen leitet und Ihnen die aktuellen Downloadlinks für Ihr INSTAR Produkt anzeigt.`}</p>
    <p><strong parentName="p">{`Schnellinstallations-Assistent`}</strong>{`: Der Assistent leitet Sie durch die wichtigsten Schritte um Ihr INSTAR Produkt in Betrieb zu nehmen.`}</p>
    <p><strong parentName="p">{`Software Installation`}</strong>{`: Sie finden Download Links sofern Ihr INSTAR Produkt zusätzliche Software benötigt. Sie werden durch alle Schritte geleitet nachdem Sie den Download und die Installation abgeschlossen haben.`}</p>
    <p><strong parentName="p">{`Firmware Updates`}</strong>{`: INSTAR bietet in regelmäßigen Abständen Firmware und WebUI Updates für seine Produkte an. Weiter unten finden Sie die aktuellen Versionen der Firmware und WebUI die Sie auf Ihre INSTAR Kamera aufspielen können.`}</p>
    <a href="https://install.instar.com/fullhd/install_8003.html" target="_blank" rel="noopener noreferrer"><button className="btn">Installation Starten</button></a>
    <h2 {...{
      "id": "anleitungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#anleitungen",
        "aria-label": "anleitungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Anleitungen`}</h2>
    <h3 {...{
      "id": "schnellinstallation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schnellinstallation",
        "aria-label": "schnellinstallation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schnellinstallation`}</h3>
    <p>{`Die Bedienungsanleitung beinhaltet ausführliche Informationen zu allen Funktionen der Kamera.`}</p>
    <a href="https://wiki.instar.com/dl/IN-8003HD/QuickInstallation-1080p-IN-8003HD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn">Anleitung</button></a>
    <h2 {...{
      "id": "updates-kamera-software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#updates-kamera-software",
        "aria-label": "updates kamera software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Updates Kamera-Software`}</h2>
    <h3 {...{
      "id": "firmware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#firmware",
        "aria-label": "firmware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Firmware`}</h3>
    <p>{`Sie finden hier immer die neueste Version und alle Vorgängerversionen der Firmware für Ihre Kamera. Sofern Sie ein Update der WebUI planen, stellen Sie immer sicher, dass Sie die neueste Version der Firmware installiert haben. In den meisten Fällen erfordern die neuen Funktionen in der Weboberfläche (WebUI) auch die neueste Firmware. Für Informationen wie Sie die Firmware updaten schauen Sie bitte `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/WebUI_und_Firmware_Upgrade/"
      }}>{`hier`}</a>{`.`}</p>
    <p><strong parentName="p">{`Wichtig`}</strong>{`: Entpacken Sie nach dem Download bitte die *.ZIP Datei. Beachten Sie auch das Sie zuerst die neueste Firmware installieren und erst dann die WebUI.`}</p>
    <h4 {...{
      "id": "download",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#download",
        "aria-label": "download permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Download`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28378%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (378)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS Zertifikat erneuert`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28377%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (377)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Entfernung von SSL 3.0: Aufgrund seiner Schwachstellen und der Ablehnung durch Industriestandards wurde die Unterstützung für SSL 3.0 vollständig entfernt`}</li>
          <li parentName="ul">{`Deaktivierung unsicherer Verschlüsselungsverfahren: Alle als unsicher geltenden Verschlüsselungsverfahren wurden deaktiviert`}</li>
          <li parentName="ul">{`Diese Änderungen gewährleisten die Einhaltung moderner Sicherheitsprotokolle und bewährter Methoden, um die Sicherheit zu erhöhen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28374%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (374)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Ein Problem wurde behoben, bei dem Ordner nicht mehr über FTP erstellt werden konnten`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28373%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (373)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS Zertifikat erneuert`}</li>
          <li parentName="ul">{`MQTT Alarmserver: Automatische Rückkehr in den Ruhezustand nach einer Alarmauslösung`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003_FW_4.1.2.48_WebUI_3.3.%28372%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (372)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`TLS Zertifikat erneuert`}</li>
          <li parentName="ul">{`Die Zuverlässigkeit der HomeKit-Verbindung wurde verbessert`}</li>
          <li parentName="ul">{`MQTT Topic`}<code parentName="li" {...{
              "className": "language-text"
            }}>{`features/nightvision/autoircut`}</code>{` liest jetzt den Tag Nacht/Modus korrekt aus`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.3.%28370%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.3 (370)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Elastic Search ersetzt die bisherige INSTAR-Wiki-Suche`}</li>
          <li parentName="ul">{`Der MQTT-Alarmserver Status wird automatisch zurückgesetzt.`}</li>
          <li parentName="ul">{`Ein Problem mit der FritzBox wurde gelöst, bei dem man auf ein neues unbekanntes Gerät hingewiesen wurde.`}</li>
          <li parentName="ul">{`Das HTTPS-Zertifikat wurde aktualisiert`}</li>
          <li parentName="ul">{`Die WebUI wird nicht mehr im iFrame geladen`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.2.%28366%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.2 (366)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`HomeKit Support - Fügen Sie Ihre Kamera jetzt auch in Apple's HomeKit App hinzu!`}</li>
          <li parentName="ul">{`Aktivieren / deaktivieren Sie die Kennzeichen- oder Gesichtserfassung der Cloud über das Cloud-Menü der Kamera-WebUI. Anmerkung: Die Kennzeichen- oder die Gesichtserfassung muss in Ihrem Cloud-Speicherplan vorhanden sein.`}</li>
          <li parentName="ul">{`Der textlastige Einrichtungsassistent wurde aufgeräumt und aktualisiert.`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003_FW_4.1.2.48_WebUI_3.2.%28364%29_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.2 (364)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Unterstützung des Apple Homekit Dienstes`}</li>
          <li parentName="ul">{`Aktivieren / deaktivieren Sie die Kennzeichen- oder Gesichtserfassung der Cloud über das Cloud-Menü der Kamera-WebUI. Anmerkung: Die Kennzeichen- oder die Gesichtserfassung muss in Ihrem Cloud-Speicherplan vorhanden sein.`}</li>
          <li parentName="ul">{`Der textlastige Einrichtungsassistent wurde aufgeräumt und aktualisiert.`}</li>
          <li parentName="ul">{`Sowohl der Backup-Alarmzeitplan als auch der reguläre Alarmzeitplan sinf jetzt über MQTT schaltbar.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.1.(350)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.1 (350)`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Alexa Support - Der INSTAR Cloud Skill, mit dem Sie sich das Live-Video Ihrer Kamera sowie Aufnahmen in der Cloud anzeigen lassen können, ist ab sofort verfügbar.`}</li>
          <li parentName="ul">{`IFTTT Support - Auf der IFTTT-Plattform stellen wir unseren Dienst namens INSTAR zur Verfügung. Die INSTAR Applets bieten Ihnen die Möglichkeit, einige Einstellungen Ihrer INSTAR Kamera oder INSTAR Cloud mit IFTTT zu steuern.`}</li>
          <li parentName="ul">{`Für die Nutzung von Alexa und IFTTT ist ein kostenloses INSTAR Cloud Konto notwendig. Wenn Sie sich jetzt anmelden, dann können Sie zudem 30 Tage den kostenpflichtigen Funktionsumfang wie z.B. die Speicherung von Alarmvideos gratis testen.`}</li>
          <li parentName="ul">{`Mit Alexa und IFTTT wurde die neue Menü-Kategorie Smarthome eingeführt. Die Alarmserver- und MQTT-Einstellungen finden Sie ab sofort unter Smarthome.`}</li>
          <li parentName="ul">{`MQTT Topic-Präfix und Klient-ID definierbar`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_3.0.(328)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 3.0`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Audio-Unterstützung für den Safari-Browser (HTML5-Videostream)`}</li>
          <li parentName="ul">{`Vollbildansicht für HTML5- und MJPEG-Streams durch Doppelklicken oder Schnelltaste`}</li>
          <li parentName="ul">{`HTML5-Audio-Stream kann mit der Schnelltaste stummgeschaltet werden`}</li>
          <li parentName="ul">{`Die zeitgesteuerte IR-Steuerung wurde mit der Schaltzeit des IRcuts verknüpft`}</li>
          <li parentName="ul">{`Zeitplan für den WDR-Modus ist jetzt verfügbar`}</li>
          <li parentName="ul">{`Zeiteinstellungen haben jetzt Priorität und werden angewendet, wenn die aktuelle Zeit übereinstimmt`}</li>
          <li parentName="ul">{`Der SD-Karten-Viewer wurde überarbeitet. Es können nun mehrere Dateien gleichzeitig heruntergeladen werden.`}</li>
          <li parentName="ul">{`Das Alarm-Menü wurde neu organisiert.`}</li>
          <li parentName="ul">{`Sie können jetzt die Aufzeichnungsauflösung im Alarmmenü ändern`}</li>
          <li parentName="ul">{`Zukünftig werden die Benachrichtigungs-Pop-ups nach jeder Aktualisierung zurückgesetzt.`}</li>
          <li parentName="ul">{`Allgemeine Fehlerbehebungen und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.48_WebUI_2.6.(320)_update.zip"
          }}>{`FW 4.1.2.48 WebUI 2.6`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`HTML5-Videostream-Unterstützung für die neuen Browser Edge (Chrome), Google Chrome, Mozilla Firefox und Safari`}</li>
          <li parentName="ul">{`Videoeinstellungen wurden überarbeitet`}</li>
          <li parentName="ul">{`Das SSL-Zertifikat wurde für HTTPS und MQTT aktualisiert.`}</li>
          <li parentName="ul">{`Wenn das integrierte Zertifikat verwendet wird, benötigen alle MQTT-Clients, die mit diesem MQTT-Broker verbunden sind, das neue Host-Zertifikat.`}</li>
          <li parentName="ul">{`Allgemeine Fehlerbehebungen und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.47_WebUI_2.5.(308)_update.zip"
          }}>{`PoE FW 4.1.2.47 WebUI 2.5`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`PTZ-Funktionalität komplett überarbeitet `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`Es wird empfohlen einen PTZ-Reset durchzuführen! `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`Alarmunterdrückung während PTZ verfügbar `}{`[IN-9010FullHD / IN-9020FullHD]`}</li>
          <li parentName="ul">{`PTZ-Reset-Button im PTZ-Menü verfügbar`}</li>
          <li parentName="ul">{`Vereinfachte Cloud-Integrierung`}</li>
          <li parentName="ul">{`Von nun an müssen Sie die Login Daten (Email-Adresse und Cloud-Passwort) Ihres Cloud-Accounts eintragen, anstatt wie zuvor die Kamera-Cloud-Daten.`}</li>
          <li parentName="ul">{`Erweiterte Alarmserver-Funktionalitäten`}</li>
          <li parentName="ul">{`Alarmaktivierung/-deaktivierung via Schnellzugriffs-Button`}</li>
          <li parentName="ul">{`Änderung der Alarmvideolänge führen nicht mehr zum Neustart`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.47_WebUI_2.5.(288)_update.zip"
          }}>{`PoE FW 4.1.2.47 WebUI 2.5`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`4d00df34f72d15b25e7682bbe2e714e522672893c636e8226e5d6b718a4eab36`}</code>{`]`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Native Smarthome Unterstützung mit der Integration eines MQTT Broker/Client (ioBroker, OpenHAB, Node-RED, FHEM,Home Assistant und viele mehr)`}</li>
          <li parentName="ul">{`Bevorzugte BSSID für die WLAN-Anbindung einstellbar`}</li>
          <li parentName="ul">{`Ein Problem mit dem RTSP-Video wurde behoben, der bei Verwendung mit der Surveillance Station auftrat`}</li>
          <li parentName="ul">{`Änderung der Alarmvideolänge führen nicht mehr zum Neustart`}</li>
          <li parentName="ul">{`Der Ruhephasen-Intervall zwischen den Anfragen an den Alarmserver ist nun einstellbar`}</li>
          <li parentName="ul">{`Der Ruhephasen-Intervall zwischen Push-Benachrichtung während fortdauerndem Alarm ist nun einstellbar`}</li>
          <li parentName="ul">{`Alarmserver- und Push-Test`}</li>
          <li parentName="ul">{`Zeitpläne können als Vorlage gespeichert werden`}</li>
          <li parentName="ul">{`Kameras können als WebAPP auf dem Home Bildschirm des Smartphones hinterlegt werden`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.46_WebUI_2.4.(262)_update.zip"
          }}>{`PoE FW 4.1.2.46 WebUI 2.4`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`ae375b334ab754f1537aafc8756665a8ba61212090c4ef2cae2d9b00d2ba2fb0`}</code>{`]`}</p>
        <ul parentName="li">
          <li parentName="ul">{`PTZ-Funktionalität komplett überarbeitet `}{`[`}{`IN-9010FullHD / IN-9020FullHD`}{`]`}</li>
          <li parentName="ul">{`Es wird empfohlen einen PTZ-Reset durchzuführen! `}{`[`}{`IN-9010FullHD / IN-9020FullHD`}{`]`}</li>
          <li parentName="ul">{`Alarmunterdrückung während PTZ verfügbar `}{`[`}{`IN-9010FullHD / IN-9020FullHD`}{`]`}</li>
          <li parentName="ul">{`PTZ-Reset-Button im PTZ-Menü verfügbar`}</li>
          <li parentName="ul">{`Vereinfachte Cloud-Integrierung`}</li>
          <li parentName="ul">{`Von nun an müssen Sie die Login Daten (Email-Adresse und Cloud-Passwort) Ihres Cloud-Accounts eintragen, anstatt wie zuvor die Kamera-Cloud-Daten.`}</li>
          <li parentName="ul">{`Erweiterte Alarmserver-Funktionalitäten`}</li>
          <li parentName="ul">{`Alarmaktivierung/-deaktivierung via Schnellzugriffs-Button`}</li>
          <li parentName="ul">{`Änderung der Alarmvideolänge führen nicht mehr zum Neustart`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wiki.instar.com/dl/IN-8003HD/IN-8003-PoE_FW_4.1.2.43_WebUI_2.3.(242)_update.zip"
          }}>{`PoE FW 4.1.2.43 WebUI 2.3 *`}</a>{` `}{`[SHA265: `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`a2121e56b5f9387bda1ae365a8e05fb8f652f3fe600a9749b63ea2e3bbc0b651`}</code>{`]`}{` **`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Unterstützung von benutzerdefinierten SSL-Zertifikaten für HTTPS-Verbindungen mit der eigenen DDNS-Domaine`}</li>
          <li parentName="ul">{`Vereinfachte 1-Klick-Update-Methode`}</li>
          <li parentName="ul">{`Offline Update über PKG-Datei weiterhin möglich`}</li>
          <li parentName="ul">{`Alarmvideos bis zu 60 Sekunden`}</li>
          <li parentName="ul">{`Ersteinbindung über direkte WLAN-Verbindung - Nur WLAN-Modelle! Diese Funktion ist nur bei Neugeräten bzw. nur nach einem Werksreset einmalig möglich und wird nach der Einrichtung des WLANs permanent deaktiviert`}</li>
          <li parentName="ul">{`Ein Fehler bei unsichtbaren WLAN-SSIDs wurde behoben`}</li>
          <li parentName="ul">{`IR-CUT-Filter Steuerung`}</li>
          <li parentName="ul">{`Das Wetter-Widget wurde entfernt * 1`}</li>
          <li parentName="ul">{`Werksreset- und WPS-Aktivierung über die SD-Karte wurde vereinfacht * 2`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
        <ul parentName="li">
          <li parentName="ul">{`1 Der Wetterdatendienst von Yahoo Weather wurde in seiner bisherigen Form eingestellt. Diese Funktion wird in einem späteren Update wieder integriert.`}</li>
          <li parentName="ul">{`2 Reset und WPS via SD-Karte können nun auch durch Textdateien mit der Dateierweiterung .txt ausgeführt werden. Für den Reset müssen Sie eine leere Datei mit dem Namen “reset” oder “reset.txt” im Root-Verzeichnis der SD-Karte erstellen. Für die WPS-Aktivierung erstellen Sie bitte eine Datei mit dem Namen “wps” oder “wps.txt”`}</li>
        </ul>
      </li>
    </ul>
    <div className="warningbox">
 (*) Diese Version darf nur auf einem 8015 Power-over-Ethernet und nicht auf einem 8015 WLAN installiert werden.
    </div>
    <br /><br />
    <p><em parentName="p">{`** `}<a parentName="em" {...{
          "href": "/de/Downloadbereich/Sicherheit/"
        }}>{`Was ist ein SHA265 Hash?`}</a></em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      